// LobbyContent.js

import React, { useEffect, useState } from "react";

import { withTranslation } from "react-i18next";
import resultGRH_img from "../../../../src/assets/images/icons/resultImg.jpg"

const GrhResult = (props) => {
    const [result, setResult] = useState([]);

    return (
        <>
            <div className="game_item_detail GRH">
                <img src={resultGRH_img} alt="" />
            </div>
        </>
    );
}

export default withTranslation()(GrhResult);
